"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rovegno": {
    "ac1fef8e": [{
      "hkey": "08ca71e5",
      "slug": "rovegno",
      "name": "Rovegno",
      "primary": true,
      "skipSearch": false
    }],
    "moglia": [{
      "hkey": "08ca71e5",
      "slug": "rovegno",
      "name": "Rovegno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1e31d49d": [{
      "hkey": "08ca71e5",
      "slug": "rovegno",
      "name": "Rovegno",
      "primary": true,
      "skipSearch": false
    }],
    "spescia": [{
      "hkey": "08ca71e5",
      "slug": "rovegno",
      "name": "Rovegno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;